import humanizeDuration from 'humanize-duration';

// returns the time left for an opportunity
const getTimeLeft = ({
  diff = 0,
  units = [],
  dateUtc = {},
  expired = false,
}) => {
  if (expired) {
    return `Expired on ${dateUtc.toDate().toLocaleDateString()}`;
  }

  const timeLeft = humanizeDuration(diff, {
    units,
    round: true,
    largest: 2,
    delimiter: ' ',
  });

  return `${timeLeft} left`;
};

export default getTimeLeft;
